import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { number, object, string } from "prop-types";
import { Link } from "@quintype/components";
import CompanyIcon from "../../atoms/CompanyIcon";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

import "./company-card.m.css";
const CompanyCard = ({ card, cdnImage, index }) => {
  const { name, slug } = card;
  const imgUrl = get(card, ["photo", "0", "key"], null);
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  let isTracking = false;
  const handleCompanyClick = (e) => {
    if (isTracking) return;
    isTracking = true;

    setTimeout(() => {
      isTracking = false;
    }, 300);

    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      // Push to dataLayer
      window.dataLayer.push({
        event: "dl_company_list_interactions",
        link_text: name.toLowerCase(),
        link_position: index + 1,
        event_action: "company_select",
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: () => {
          window.location.href = `companies/${slug}`;
        },
      });

      setTimeout(() => {
        window.location.href = `companies/${slug}`;
      }, 100);
    }
  };

  return (
    <Link
      href={`companies/${slug}`}
      aria-label="image-fallback"
      styleName="wrapper"
      disableAjaxLinks={true}
      onMouseDown={handleCompanyClick}
      onTouchStart={handleCompanyClick}
    >
      <div styleName="imageIcon">
        {imgUrl ? (
          <img key={`${name}-${index}`} alt={name} title={name} src={`${cdnImage}/${imgUrl}?w=120&q=70`} />
        ) : (
          <CompanyIcon />
        )}
      </div>
      <div styleName="name">{name}</div>
    </Link>
  );
};

CompanyCard.propTypes = {
  card: object,
  cdnImage: string,
  index: number,
};

export default CompanyCard;
